import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { Search } from "lucide-react";
import useClickOutside from "../../../CustomHooks/useClickOutside";
import sortDataByAlphabetically from "../../../functions/sorting/sortDataByAlphabetically";
import sortDataByNumber from "../../../functions/sorting/sortDataByNumber";

const SearchDropdown = ({
  name,
  label,
  keyName,
  id,
  options,
  control,
  setValue,
  selectedVal,
  error,
  search,
  render,
  disabled,
  optionListIsNumber,
  showOptionId,
  disableValidationMessage,
  visitStationAPiCalled,
  unSort,
}) => {
  const sortedOptions = unSort
    ? options
    : optionListIsNumber
      ? sortDataByNumber(options, keyName)
      : sortDataByAlphabetically(options, [keyName]);

  const [searchList, setSearchList] = useState(sortedOptions);
  const [open, setOpen] = useState(-1);
  const { dropdownRef } = useClickOutside(() => setOpen(-1));

  const getOptionNameById = (inputId) => {
    const option = options.find((item) => item[id] === inputId);
    return option ? option[keyName] : "";
  };

  const handleShowDropdown = () => {
    setOpen((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };
  const handleOptionClick = (id, keyName) => {
    setValue(name, id, { shouldValidate: true });
    setOpen(-1);
    // api called when station is selected on add visit form
    if (visitStationAPiCalled) {
      visitStationAPiCalled(id);
    }
  };
  // ----------------- Hnadle Search -----------------------------------------
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();

    if (value.length) {
      const filter = options.filter((item) => {
        const matchesName = item[keyName]
          ?.toString()
          .toLowerCase()
          .includes(value);

        const matchesId =
          showOptionId && item[id]?.toString().toLowerCase().includes(value);

        return matchesName || matchesId;
      });

      setSearchList(
        unSort ? filter : sortDataByAlphabetically(filter, [keyName]),
      );
    } else {
      setSearchList(sortedOptions);
    }
  };

  useEffect(() => {
    setSearchList(sortedOptions);
  }, [render, options]);

  return (
    <div className="relative">
      <label
        htmlFor={name}
        className="font-poppins text-gray-500 text-xs lg:text-sm"
      >
        {label}
      </label>
      <div className="relative" ref={dropdownRef}>
        <p onClick={() => handleShowDropdown()}>
          <Controller
            control={control}
            name={name}
            defaultValue="" // Ensures no default selection
            rules={{
              validate: (value) =>
                disableValidationMessage ||
                value !== "" ||
                "Please select an option",
            }}
            render={({ field }) => (
              <>
                <span
                  className={`font-poppins absolute right-2 top-2 lg:top-3 cursor-pointer font-semibold ${
                    open === 1 ? "rotate-90" : "rotate-90n"
                  }`}
                >{`<`}</span>
                {field.value !== "" && (
                  <span className="text-xs lg:text-sm font-figtree absolute left-2 lg:left-3 top-[9px] lg:top-3 bg-white w-1/2">
                    {getOptionNameById(field.value)}
                  </span>
                )}
                <input
                  name={name}
                  type="text"
                  readOnly="readonly"
                  placeholder="Select"
                  onChange={() => field.onChange(field.value)}
                  className={`dropdown-li-search ${
                    error ? "border-red-500" : "border-lg4"
                  }`}
                  disabled={disabled}
                />
              </>
            )}
          />
        </p>
        <div
          className={`checksOptionWrap ${
            open === 1 ? "grid opacity-1" : "invisible opacity-0"
          }`}
        >
          {search ? (
            <p className="mb-2">
              <input
                type="text"
                placeholder="Search"
                onChange={handleSearch}
                className="cy-search-inp"
              />
              <Search size={16} className="absolute right-4 top-4" />
            </p>
          ) : (
            ""
          )}
          {searchList.length > 0 ? (
            <ul
              className={`${
                searchList.length > 6 ? "overflow-y-scroll h-40" : ""
              }`}
            >
              {searchList.map((item, index) => {
                return (
                  <li
                    onClick={() => handleOptionClick(item[id], item[keyName])}
                    className={`dropdown-li ${
                      selectedVal === item[id] ? "bg-lb3" : ""
                    }`}
                    key={`${id}-${index}`}
                  >
                    {`${item[keyName]}${
                      showOptionId ? ` - (${item[id]})` : ""
                    }`}
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="cy-dropdown-search-err">Not Found</p>
          )}
        </div>
        <p className={`input-err ${error ? "visible" : "invisible"}`}>
          {error?.message}
        </p>
      </div>
    </div>
  );
};

export default SearchDropdown;
